import { render, staticRenderFns } from "./sidebarLayout.vue?vue&type=template&id=08f6eed6&scoped=true"
import script from "./sidebarLayout.vue?vue&type=script&lang=js"
export * from "./sidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./sidebarLayout.vue?vue&type=style&index=0&id=08f6eed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6eed6",
  null
  
)

export default component.exports